import { CSSProperties } from "react";
import { Button } from "antd";
import styled from "styled-components";

export const AddButton = styled(Button)`
  background-color: ${(props) => props.theme["@primary-color-brand"]};
  border-radius: ${(props) => props.theme["@round-component-border-radius"]};
  color: ${(props) => props.theme["@default-color"]};
  font-family: ${(props) => props.theme["@font-family"]};
  border-color: ${(props) => props.theme["@primary-color-brand"]};
  font-size: ${(props) => props.theme["@large-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  border: none;
  width: 190px;
  height: ${(props) => props.theme["@height-button-lg"]};
  padding: 0;
  margin: 0;
  margin-bottom: 12px;
  &:hover,
  &:focus {
    background-color: ${(props) => props.theme["@hover-input-background-color"]};
    color: ${(props) => props.theme["@default-color"]};
    border: none;
  }
`;

export const AddButtonCol: CSSProperties = {
  paddingTop: 0,
};
